<template>
    <div class="calendar">
      <div :class="[
              'calendar-header', 
              context === 'event-dates'? ['feathered-edges', 'bottom'] : '',
            ]"
      >
          <h3 
            :class="[
                'month-title',
                ,

              ]"
          >{{ monthTitle }}</h3>
      </div>
      <div class="calendar-grid">
        <!-- Cabeçalho dos dias da semana -->
        <div
          class="weekday"
          v-for="(day, index) in weekdays"
          :key="`weekday-${index}`"
        >
          {{ day }}
        </div>
        <!-- Dias do mês -->
        <div
          v-for="(day, index) in daysInMonth"
          :key="day.date || `empty-${index}`"
          :class="['day', getDayClass(day)]"
          @click="selectDate(day)"
        >
          {{ day.label }}
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
  name: "CustomCalendar",
  props: {
    availableDates: {
      type: Array,
      required: false,
      default: () => [] // Por padrão, nenhuma data está disponível
    },
    selectedColors: { 
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: String,
      default: null
    },
    allowedDates: {
      type: Function,
      default: () => () => true // Por padrão, todas as datas são permitidas
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    currentMonth:{
        typeof: String,
        default: new Date().getMonth()
    },
    currentYear:{
        typeof: String,
        default: new Date().getFullYear()
    },
    eventTimes: {
      type: Object,
      default: () => ({})
    },
    context: {
      type: String,
      default: "",
    },
    selectedOption: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      selectedDate: this.modelValue, // Data inicial selecionada
      //currentMonth: new Date().getMonth(),
      //currentYear: new Date().getFullYear(),
      weekdays: ["D", "S", "T", "Q", "Q", "S", "S"]
    };
  },
  computed: {
    monthTitle() {
      const monthNames = [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
      ];
      return `${monthNames[this.currentMonth]}`;
    },
    daysInMonth() {
      const days = [];
      const firstDay = new Date(this.currentYear, this.currentMonth, 1).getDay();
      const totalDays = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
      const month = this.currentMonth + 1;

      // Preenche com espaços vazios para alinhar o primeiro dia do mês
      for (let i = 0; i < firstDay; i++) {
        days.push({ label: "", available: false, date: null });
      }

      // Adiciona os dias reais do mês
      for (let day = 1; day <= totalDays; day++) {
        const date = `${this.currentYear}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
        const isAllowed =
          (!this.min || date >= this.min) &&
          (!this.max || date <= this.max) &&
          this.allowedDates(date);

        days.push({
          label: day,
          available: isAllowed && this.availableDates.includes(date),
          date
        });
      }

      return days;
    },
    getEventTimes(){
      return this.eventTimes
    }
  },
  methods: {
    isSelected(date) {
      return this.selectedDate === date;
    },
    selectDate(day) {
      if (day.available) {
        this.selectedDate = day.date;
        this.$emit("input", this.selectedDate); // Emite o evento @input
        //this.$emit("update:vModel", this.selectedDate); // Atualiza o v-model
        this.$emit("update:modelValue", this.selectedDate, this.selectedOption); // Atualiza o v-model
        this.$emit("reload-calendar");
      }
    },
    getDayClass(day) {
      if (!day.available) return 'disabled-day';

      const events = this.getEventTimes[day.date];
      if (!events || !Array.isArray(events) || !events.length) {
        return 'available';
      }

      // apanhar apenas valores válidos (0,1,2,3) e ignorar null/undefined
      const values = [...new Set(
        events
          .map(e => e.value)
          .filter(v => v !== null && v !== undefined)
      )].sort((a, b) => a - b);

      if (!values.length) {
        return 'available';
      }

      const classMapping = {
        "1": "red-day",
        "2": "yellow-day",
        "3": "green-day",
        "0": "available",
        "1-2": "red-yellow-day",
        "1-3": "red-green-day",
        "0-1": "red-white-day",
        "2-3": "yellow-green-day",
        "0-2": "yellow-white-day",
        "0-3": "green-white-day",
        "1-2-3": "red-yellow-green-day",
        "0-1-2": "red-yellow-white-day",
        "0-1-3": "red-green-white-day",
        "0-2-3": "yellow-green-white-day",
        "0-1-2-3": "red-yellow-green-white-day",
      };

      const key = values.join('-');
      return classMapping[key] || 'available';
    }
  },
  watch: {
    modelValue(newVal) {
      this.selectedDate = newVal; // Atualiza a data selecionada quando o v-model muda
    },
    eventTimes(newValue) {
        console.log('eventTimes foi atualizado para:', newValue);
    }
  }
};


  </script>
  
  <style scoped>
  .calendar {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: Arial, sans-serif;
  }
  
  .month-title1 {
    font-size: 24px;
    margin-bottom: 16px;
    color: black;

  }
  
  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-template-rows: repeat(6, 1fr);
    gap: 4px;
    width: 100%;
    min-height: 288px ;
    /* min-width: 288px; */

    @media (min-width: 400px) {
      gap: 9px;
    }
  }
  .weekday,
  .day{
    display: flex;
    color: var(--app-color-text-primary);
    justify-content: center;
  }
  .weekday {
    /* text-align: center; */
    font-weight: bold;
    /* color: black; */
    align-items: flex-end;
  }
  
  .day {
    /* width: 39px;
    height: 39px; */
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: white !important;
    /* color: black; */
    font-size: 14px;
    cursor: pointer;
  }

  .day:not(.disabled-day)
  {
    cursor: pointer !important;
  }
  
  .day.available {
    background-color: white;
  }
  
  .day.selected {
    background-color: #6c63ff;
    color: white;
  }
  
  .day:not(.available) {
    cursor: default;
    opacity: 0.3;
  }

  .day.red-day {
    background-color: var(--app-color-error) !important;
    color: black;
    opacity: 1;
  }

  .day.yellow-day {
    background-color: var(--app-color-warning) !important;
    color: black;
    opacity: 1;
  }

  .day.green-day {
    background-color: var(--app-color-success) !important;
    color: black;
    opacity: 1;
  }

  .day.yellow-green-day {
    background: linear-gradient(to bottom, var(--app-color-warning) 50%, var(--app-color-success) 50%);
    opacity: 1;
  }

  .day.yellow-white-day {
    background: linear-gradient(to bottom, var(--app-color-warning) 50%, #fff 50%);
    opacity: 1;
  }

  .day.red-yellow-day {
    background: linear-gradient(to bottom, var(--app-color-error) 50%, var(--app-color-warning) 50%);
    opacity: 1;
  }

  .day.red-green-day {
    background: linear-gradient(to bottom, var(--app-color-error) 50%, var(--app-color-success) 50%);
    opacity: 1;
  }

  .day.red-white-day {
    background: linear-gradient(to bottom, var(--app-color-error) 50%, #ffffff 50%);
    opacity: 1;
  }

  .day.green-white-day {
    background: linear-gradient(to bottom, var(--app-color-success) 50%, #fff 50%);
    opacity: 1;
  }

  .day.red-yellow-green-white-day {
    background: linear-gradient(
      to bottom,
      var(--app-color-error) 25%,
      var(--app-color-warning) 25% 50%,
      var(--app-color-success) 50% 75%,
      #ffffff 75%
    );
    opacity: 1;
  }

  .day.red-yellow-green-day {
    background: linear-gradient(
    to bottom,
    var(--app-color-error) 33.3%,
    var(--app-color-warning) 33.3% 66.6%,
    var(--app-color-success) 66.6%
  );
  opacity: 1;
  }

  .day.red-yellow-white-day {
    background: linear-gradient(
    to bottom,
    var(--app-color-error) 33.3%,
    var(--app-color-warning) 33.3% 66.6%,
    #ffff 66.6%
    );
    opacity: 1;
  }

  .day.red-green-white-day {
    background: linear-gradient(
    to bottom,
    var(--app-color-error) 33.3%,
    var(--app-color-success) 33.3% 66.6%,
    #ffff 66.6%
    );
    opacity: 1;
  }

  .day.yellow-green-white-day {
    background: linear-gradient(
    to bottom,
    var(--app-color-success) 33.3%,
    var(--app-color-warning) 33.3% 66.6%,
    #ffff 66.6%
    );
    opacity: 1;
  }

  .calendar-header {
    position: sticky;
    width: 100%;
    top: 0;
    text-align: center;
    background-color: var(--app-color-bg-primary);
    /* needs to be 3 so it's on the same layer or 
    above the feathered edges from availability buttons */
    z-index: 3;
}

  @media screen and (max-width: 768px) {
    .month-title1{
      font-size: 20px !important;
      font-weight: 500;
    }
  }

  </style>
  